import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LinkModule } from './shared/link/link.module';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { LoginComponent } from './auth/login/login.component';
import { SignupComponent } from './auth/signup/signup.component';
import { UnauthComponent } from './auth/unauth/unauth.component';
import { httpInterceptorProviders } from './auth/interceptor';
import { LandingComponent } from './auth/landing/landing.component';
import { ErrorhandlerService } from './errorhandler.service';
import { MapService } from './map.service';
import { OrderByModule } from './shared/sorting-pipe/orderBy-module';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from './modules/pagination/pagination.module';
import {CommonService} from './common.service'
import { HttpClientModule } from '@angular/common/http';
import { IntouchWidgetModule } from './shared/intouch-widget/intouch-widget.module';
import { NavigationStart, Router } from '@angular/router';
import { AccountCreationComponent } from './account-creation/account-creation.component';
import { FieldUserComponent } from './auth/field-user/field-user.component';
import { GeStartedComponent } from './auth/get-started/get-started.component';
import { AttendanceModule } from './attendance-module/attendance.module';
import { WebSocketService } from './web-socket.service';
import { CustomFieldsFilterModule } from './shared/customFieldsFilter-pipe/customFieldFilter.module';
import { CustomPreloadingStrategy } from './custom-preloading-strategy';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    SignupComponent,
    UnauthComponent,
    LandingComponent,
    AccountCreationComponent,
    FieldUserComponent,
    GeStartedComponent
  ],
  imports: [
    BrowserModule,
    LinkModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    AttendanceModule,
    OrderByModule,
    PaginationModule,
    NgSelectModule,
    IntouchWidgetModule,
    CustomFieldsFilterModule,
   
    
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    httpInterceptorProviders,
    ErrorhandlerService,
    MapService,
    CommonService,
    DatePipe,
    WebSocketService,
    CustomPreloadingStrategy
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(public router: Router) {
    console.log("Appmodule is starting")
    router.events.subscribe(s => {
      if (s instanceof NavigationStart &&
               (s.toString().indexOf("access_token")>0) && (s.toString().indexOf("landing")<0) ){ 
                 let tokenReceived=window.location.hash;
                 tokenReceived = tokenReceived.replace('#','');
        // this.decodeToken(tokenReceived);
        // alert("module hash=>"+tokenReceived)
        router.navigate(['landing'],{fragment:tokenReceived});
      }
    });
 }
}
